import React, { useEffect, useState } from "react";
import { apibaseurl } from "../../../environment";

interface CandidateDetailsProps {
  addressInfo?: any;
}

const YourLocation: React.FC<CandidateDetailsProps> = ({ addressInfo }) => {
  const [mapUrl, setMapUrl] = useState("");

  const latitude = addressInfo?.address_latitude;
  const longitude = addressInfo?.address_longitude;
  const preview = addressInfo?.live_selfie_url;

  const serverImage = `${apibaseurl}${preview}`;

  const getCurrentLocation = () => {
    setMapUrl(
      `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`,
    );
  };

  useEffect(() => {
    if (latitude && longitude) {
      getCurrentLocation();
    }
  }, [latitude, longitude]);

  return (
    <>
      {/* ================== Your Location =============== */}
      <div className="card border-0">
        {/* <div className="card-header bg-white py-3">
          <h5 className="fw-bold mb-0">
            <i
              className="ti ti-map-pin-share me-2"
              style={{ color: "#F26522" }}
            ></i>
            Address Verification Summary
          </h5>
        </div> */}

        <div className="card-body">
          <div className="row g-4">
            {/* ================= Location ================= */}

            <div className="col-lg-6">
              <div className="border rounded-3 h-100 onerflow-hidden">
                <div
                  className="px-3 py-3 border-bottom"
                  style={{ background: "#fafafa" }}
                >
                  <h5 className="fw-semibold mb-1">
                    <i
                      className="ti ti-map-2 me-2"
                      style={{ color: "#F26522" }}
                    ></i>
                    Captured Location
                  </h5>

                  <small className="text-muted">
                    GPS coordinates captured during verification.
                  </small>
                </div>

                <div className="p-3">
                  {latitude && longitude && (
                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Latitude
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          value={latitude}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Longitude
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          value={longitude}
                          readOnly
                        />
                      </div>
                    </div>
                  )}

                  <div
                    className="rounded overflow-hidden border"
                    style={{
                      height: "350px",
                    }}
                  >
                    <iframe
                      title="Google Map"
                      src={mapUrl ? mapUrl : ""}
                      width="100%"
                      height="100%"
                      style={{
                        border: 0,
                      }}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ================= Selfie ================= */}

            <div className="col-lg-6">
              <div className="border rounded-3 h-100">
                <div
                  className="px-3 py-3 border-bottom"
                  style={{ background: "#fafafa" }}
                >
                  <h5 className="fw-semibold mb-1">
                    <i
                      className="ti ti-camera me-2"
                      style={{ color: "#F26522" }}
                    ></i>
                    Captured Selfie
                  </h5>

                  <small className="text-muted">
                    Live selfie submitted by the candidate.
                  </small>
                </div>

                <div className="p-3">
                  <div
                    className="rounded-3 d-flex justify-content-center align-items-center"
                    style={{
                      border: "2px dashed #E3E6EA",
                      background: "#FAFBFC",
                      height: "420px",
                    }}
                  >
                    {preview ? (
                      <img
                        src={serverImage}
                        alt="Preview"
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "380px",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div className="text-center text-muted">
                        <i
                          className="ti ti-photo"
                          style={{
                            fontSize: "55px",
                          }}
                        ></i>

                        <p className="mt-3 mb-0">Selfie not available</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YourLocation;
